export const SidebarIcon = ({ icon, link }) => {
  return (
    <li>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <i className={'icon-' + icon} />
      </a>
    </li>
  );
};
